import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectComponent } from './redirect.component';

@NgModule({
  declarations: [RedirectComponent],
  imports: [
    CommonModule
  ]
})
export class RedirectModule { }
